// extracted by mini-css-extract-plugin
module.exports = {"stagger":"StaggerText-module--stagger--1U_2O","show":"StaggerText-module--show--2vjz7","force":"StaggerText-module--force--3jgBj"};